import c from "../string/truncate.mjs";
const u = 40;
function d(e, t) {
  if (e) {
    const { street: r, city: n } = e, a = (t == null ? void 0 : t.streetMaxLength) || u;
    return [r && c(r, a), n].filter(Boolean).join(", ") || "";
  }
  return "";
}
export {
  d as default
};
